<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.education')" filterable clearable
      :size="size" class="d-block">
      <el-option v-for="(education,index) in educations" :key="'educations-' + index" :label="education.name" :value="education.name"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
      size: {
        default: 'small'
      },
      placeholder: {
        default: null,
      },
      id:{
        default: null
      }
    },
    watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.educations && this.educations.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        educations: 'education/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'education/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
